module.exports = __webpack_public_path__ + "img/spartan-roof-replacement-waterproofing-06-tablet.f236d946.jpg";